(function () {
  'use strict';
  const owners = new Set();
  let saved = null;
  const bodyProperties = ['position', 'top', 'width', 'overflow', 'padding-right'];
  const lock = {
    acquire(owner) {
      if (owners.has(owner)) return;
      if (!owners.size) {
        const body = document.body;
        const header = document.querySelector('[data-header]');
        saved = { y: window.scrollY, x: window.scrollX, flag: window.isScrollLocked, header, headerHidden: header && header.classList.contains('header-hidden'), styles: bodyProperties.map(key => [key, body.style.getPropertyValue(key), body.style.getPropertyPriority(key)]) };
        const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
        window.isScrollLocked = true;
        // Other existing drawers also fix the body; retain their original offset.
        if (body.style.position !== 'fixed') {
          Object.assign(body.style, { position: 'fixed', top: `-${saved.y}px`, width: '100%', overflow: 'hidden', paddingRight: `${padding + scrollbar}px` });
        } else body.style.overflow = 'hidden';
      }
      owners.add(owner);
    },
    release(owner) {
      if (!owners.delete(owner) || owners.size || !saved) return;
      const snapshot = saved;
      saved = null;
      snapshot.styles.forEach(([key, value, priority]) => value ? document.body.style.setProperty(key, value, priority) : document.body.style.removeProperty(key));
      const html = document.documentElement;
      const behavior = html.style.getPropertyValue('scroll-behavior');
      const priority = html.style.getPropertyPriority('scroll-behavior');
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(snapshot.x, snapshot.y);
      if (behavior) html.style.setProperty('scroll-behavior', behavior, priority);
      else html.style.removeProperty('scroll-behavior');
      window.isScrollLocked = snapshot.flag;
      if (snapshot.header) snapshot.header.classList.toggle('header-hidden', !!snapshot.headerHidden);
    }
  };

  function focusable(root) {
    return Array.from(root.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,[tabindex]')).filter(node => !node.disabled && node.tabIndex >= 0 && node.getClientRects().length && !node.closest('[inert]'));
  }
  function trap(root, event) {
    if (event.key !== 'Tab') return;
    const nodes = focusable(root);
    if (!nodes.length) { event.preventDefault(); root.focus(); return; }
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !nodes.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !nodes.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  }

  document.addEventListener('alpine:init', function () {
    Alpine.data('pianoMenu', function () {
      let observer, opener;
      return {
        isOpen: false, activeCategory: null, hasMore: false,
        init() {
          this.$watch('isOpen', open => {
            if (open) { opener = document.activeElement; lock.acquire(this.$el); }
            else { lock.release(this.$el); this.activeCategory = null; if (opener && opener.isConnected) opener.focus({ preventScroll: true }); }
            this.$nextTick(() => { this.updateMore(); if (open) { const first = focusable(this.$el)[0]; if (first) first.focus({ preventScroll: true }); } });
          });
          this.$watch('activeCategory', () => this.$nextTick(() => { this.$refs.scroll.scrollTop = 0; this.updateMore(); }));
          this.$nextTick(() => {
            if (window.ResizeObserver) {
              observer = new ResizeObserver(() => this.updateMore());
              observer.observe(this.$refs.scroll);
              Array.from(this.$refs.scroll.children).forEach(child => observer.observe(child));
            }
          });
          this.onResize = () => this.updateMore();
          window.addEventListener('resize', this.onResize);
        },
        updateMore() {
          const scroller = this.$refs.scroll;
          this.hasMore = !!(this.isOpen && scroller && scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop > 2);
        },
        trapFocus(event) { trap(this.$el, event); },
        destroy() { if (observer) observer.disconnect(); window.removeEventListener('resize', this.onResize); lock.release(this.$el); }
      };
    });

    Alpine.data('pianoPopup', function () {
      let release;
      return {
        init() {
          const root = this.$el;
          const panel = root.querySelector('[data-popup-panel]');
          const body = root.querySelector('[data-popup-body]');
          let opener = null;
          function viewport() {
            if (window.visualViewport) {
              root.style.setProperty('--pn-viewport-height', `${window.visualViewport.height}px`);
              root.style.setProperty('--pn-viewport-top', `${window.visualViewport.offsetTop}px`);
            }
          }
          function listen(add) {
            if (!window.visualViewport) return;
            const method = add ? 'addEventListener' : 'removeEventListener';
            window.visualViewport[method]('resize', viewport);
            window.visualViewport[method]('scroll', viewport);
          }
          release = () => { listen(false); lock.release(root); };
          Alpine.store('popup', {
            isOpen: false, content: '', buttons: [], contentClass: '', disablePadding: false,
            open(content, buttons = [], contentClass = '', disablePadding = false) {
              if (!this.isOpen) opener = document.activeElement;
              this.content = content;
              this.buttons = buttons;
              this.contentClass = contentClass;
              this.disablePadding = typeof disablePadding === 'object' ? !!disablePadding.disablePadding : !!disablePadding;
              this.isOpen = true;
              lock.acquire(root);
              viewport();
              listen(true);
              Alpine.nextTick(() => {
                if (!this.isOpen) return;
                body.scrollTop = 0;
                root.querySelector('[data-popup-close]').focus({ preventScroll: true });
              });
            },
            close() {
              if (!this.isOpen) return;
              this.isOpen = false;
              release();
              this.content = '';
              this.buttons = [];
              this.contentClass = '';
              if (opener && opener.isConnected) opener.focus({ preventScroll: true });
              opener = null;
            },
            handleKey(event) {
              if (!this.isOpen) return;
              if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
              else trap(panel, event);
            }
          });
        },
        destroy() { if (release) release(); }
      };
    });
  });
})();
